<template>
  <v-select
      v-if="visible"
      :items="selectableCorporations"
      :label="$t('corporation.singular')"
      item-text="name"
      item-value="id"
      @change="changeCorporation"
      :value="corporation"
      dense
      hide-details="auto"
      class="admin-corporation-switch"
  />
</template>
<script>
import UserSessionStateService from '@/services/UserSessionStateService';

export default {
  name: 'AdminCorporationSwitch',
  computed: {
    selectableCorporations() {
      return this.$store.getters['userSessionStateStore/selectableCorporations'];
    },
    corporation() {
      return this.$store.getters['userSessionStateStore/corporation'];
    },
    visible() {
      return this.$featurePermissions.corporationSwitching;
    },
  },
  methods: {
    changeCorporation(corporationId) {
      UserSessionStateService.changeCorporation(corporationId).then(() => {
        //reloading frontpage to make sure there is no remnants of state belongin to previously selected corporation
        window.location.href = this.$router.resolve('/status').href;
      });
    },
  },
};
</script>
